import React from 'react'
import { withAllContexts } from '../../../AllContextsWrapper';
import { TextField, Autocomplete, MenuItem, CircularProgress } from "@mui/material";
import { enqueueSnackbar } from 'notistack';
import { PlusCircle, Plus } from 'lucide-react';

class AddFee extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      isLoading: false,
      form: {
        added_by: this.props.socketIO.user.id,
        reservation: this.props.reservation.id,
        category: "transport",
        description: "",
        price: 0,
        amount: 1,
      }
    };
  }

  getData = (category) => {
    if (category === "transport") {
      this.props.socketIO.socket.emit('places:getAll', (response) => {
        if (response.success === true) {
          for (let i = 0; i < response.data.length; i++) {
            response.data[i].description = response.data[i]['name'];
            delete response.data[i].name;
          }
          let a = response.data.map((d) => {
            return {
              label: d.description,
              id: d.id,
              price: d.price
            }
          });
          this.setState({
            data: a
          })
        } else {
          this.setState({
            data: []
          })
        }
      });
    } else {
      this.props.socketIO.socket.emit('feetemplate:getAll', (response) => {
        if (response.success === true) {
          let a = response.data.map((d) => {
            return {
              label: d.description,
              id: d.id,
              price: d.price
            }
          });
          this.setState({
            data: a
          })
        } else {
          this.setState({
            data: []
          })
        }
      });
    }
  }

  componentDidMount() {
    if (this.props.reservation) {
      this.getData(this.state.form.category);
    }
  }

  handleCategory = (value) => {
    this.setState({
      form: {
        added_by: this.props.socketIO.user.id,
        reservation: this.props.reservation.id,
        category: value,
        description: "",
        price: 0,
        amount: 1
      }
    }, () => this.getData(value))
  }

  handleDescriptionChange = (description, price) => {
    this.setState(prevState => ({
      form: {
        ...prevState.form,
        description: description,
        price: price
      }
    }), () => {
      if(price) {
        this.getPrice(this.state.form.description)
      }
    })
  }

  updateFormState = (value, name) => {
    this.setState(prevState => ({
      form: {
        ...prevState.form,
        [name]: value
      }
    }))
  }

  getPrice = (description) => {
    let data = this.state.data;
    for (let i = 0; i < data.length; i++) {
      if (data[i].description === description) {
        this.setState(prevState => ({
          form: {
            ...prevState.form,
            price: data[i].price
          }
        }))
      }
    }
  }

  handleFormSubmit = async (event) => {
    event.preventDefault();
    this.setState({ isLoading: true });

    this.props.socketIO.socket.emit('fee:create', this.state.form, (response) => {
      this.setState({ isLoading: false });
      if (response.success === true) {
        this.props.app.functions.updateCurrReservation(this.props.reservation.id, false, () => {
          this.props.app.functions.updateMainCalendar();
        });
        enqueueSnackbar("Poplatok úspešne pridaný", { variant: "success" });
        
        // Reset form
        this.setState(prevState => ({
          form: {
            ...prevState.form,
            reservation: this.props.reservation.id,
            category: "transport",
            description: "",
            price: 0,
            amount: 1,
          }
        }))
      } else {
        enqueueSnackbar("Poplatok sa nepodarilo pridať", {
          variant: "error",
        });
      }
    });
  }

  render() {
    const { activeCalendar } = this.props.app.state;
    const isCamping = activeCalendar?.type === 'accommodation';
    const primaryBgClass = isCamping ? "bg-taborisko-pine hover:bg-taborisko-pine/90" : "bg-splavma-teal hover:bg-splavma-teal/90";
    const primaryColor = isCamping ? "#1A3C34" : "#0D5D56";

    const inputClass = "w-full px-4 py-3 bg-white border border-gray-200 rounded-xl focus:ring-2 focus:ring-primary-500/20 focus:border-primary-500 transition-all outline-none text-sm font-medium";
    const labelClass = "block text-[10px] font-bold text-gray-400 uppercase tracking-widest mb-1.5 ml-1";

    return (
      <div className="bg-white shadow-sm border border-gray-200">
        <div className="px-6 py-4 border-b border-gray-100 bg-gray-50/50 flex items-center gap-2">
          <PlusCircle className="w-5 h-5 text-gray-400" />
          <h3 className="font-bold text-gray-700 uppercase tracking-wide text-sm">Pridať nový poplatok</h3>
        </div>
        
        <form onSubmit={this.handleFormSubmit} className="p-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-5 items-end">
            <div className="lg:col-span-1">
              <label className={labelClass}>Kategória</label>
              <select
                value={this.state.form.category}
                onChange={(e) => this.handleCategory(e.target.value)}
                className={inputClass}
              >
                <option value="transport">Prevoz</option>
                <option value="camping">Táborisko</option>
                <option value="other">Iné</option>
              </select>
            </div>
            
            <div className="lg:col-span-2">
              <label className={labelClass}>Popis / Šablóna</label>
              <Autocomplete
                disablePortal
                options={this.state.data}
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '0.75rem',
                    padding: '3px 12px',
                    backgroundColor: 'white',
                    '& fieldset': { borderColor: '#e5e7eb' },
                    '&:hover fieldset': { borderColor: '#d1d5db' },
                    '&.Mui-focused fieldset': { borderColor: primaryColor, borderWidth: '1px' },
                  },
                  '& .MuiInputBase-input': { fontSize: '0.875rem', fontWeight: 500 }
                }}
                renderInput={(params) => <TextField {...params} variant="outlined" placeholder="Vyberte alebo napíšte..." />}
                onInputChange={(event, value, reason) => {
                  if (reason === 'input') {
                    this.handleDescriptionChange(value);
                  }
                }}
                onChange={(event, option, reason) => {
                  if (reason === 'selectOption') {
                    this.handleDescriptionChange(option.label, option.price);
                  }
                }}
                freeSolo
                value={this.state.form.description}
                fullWidth
              />
            </div>
            
            <div className="lg:col-span-1 grid grid-cols-2 gap-3">
              <div>
                <label className={labelClass}>Cena (€)</label>
                <input
                  type="number"
                  step="0.01"
                  className={inputClass}
                  value={this.state.form.price}
                  onChange={(e) => this.updateFormState(e.target.value, "price")}
                />
              </div>
              <div>
                <label className={labelClass}>Ks</label>
                <input
                  type="number"
                  className={inputClass}
                  value={this.state.form.amount}
                  onChange={(e) => this.updateFormState(e.target.value, "amount")}
                />
              </div>
            </div>
            
            <div className="lg:col-span-1">
              <button
                type="submit"
                disabled={this.state.isLoading}
                className={`w-full flex items-center justify-center gap-2 min-h-[56px] py-3.5 px-6 rounded-xl font-bold uppercase tracking-wider text-sm text-white transition-all shadow-sm hover:shadow-md disabled:opacity-70 ${primaryBgClass}`}
              >
                {this.state.isLoading ? (
                  <CircularProgress size={20} color="inherit" />
                ) : (
                  <>
                    <Plus className="w-5 h-5 flex-shrink-0" />
                    <span className="truncate">Pridať poplatok</span>
                  </>
                )}
              </button>
            </div>
          </div>
        </form>
      </div>
    );
  }
}

export default withAllContexts(AddFee);
